import { hotRanking } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

const trendIcon = (trend: string) => {
  if (trend === "up") return { icon: "ri-arrow-up-line", className: "text-primary-500" };
  if (trend === "down") return { icon: "ri-arrow-down-line", className: "text-secondary-600" };
  return { icon: "ri-subtract-line", className: "text-foreground-400" };
};

export default function HotRankingList() {
  return (
    <section id="hot" className="scroll-mt-20">
      <SectionHeading
        eyebrow="今日讨论榜"
        title="热度榜 · 实时更新"
        desc="按讨论量与转发量排序，上榜不代表内容已核实。"
      />

      <div className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
        <ul className="divide-y divide-background-200/70">
          {hotRanking.map((item) => {
            const trend = trendIcon(item.trend);
            return (
              <li key={item.rank}>
                <a
                  href="#hot"
                  className="group flex items-center gap-3 px-4 py-3.5 transition-colors hover:bg-background-100"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-semibold ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="flex-1">
                    <span className="block text-[13px] leading-snug text-foreground-800 transition-colors group-hover:text-primary-600 md:text-sm">
                      {item.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2">
                      <span className="inline-flex items-center rounded bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-900">
                        {item.tag}
                      </span>
                      <span className="text-[11px] text-foreground-400">{item.heat} 热度</span>
                    </span>
                  </span>
                  <span className={`flex h-4 w-4 shrink-0 items-center justify-center ${trend.className}`}>
                    <i className={`${trend.icon} text-base`}></i>
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
        <div className="border-t border-background-200/70 bg-background-100 px-4 py-3 text-center">
          <a
            href="#hot"
            className="cursor-pointer text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看完整榜单
          </a>
        </div>
      </div>
    </section>
  );
}